import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import { supabase } from './lib/supabaseClient';
import { Toaster } from 'react-hot-toast';
import IdleTimer from './components/IdleTimer';

import Home from './pages/Home';
import About from './pages/About';
import Courses from './pages/Courses';
import CourseDetails from './pages/courses/CourseDetails';
import Register from './pages/Register';
import Login from './pages/Login';
import FAQs from './pages/FAQs';
import Contact from './pages/Contact';
import Donate from './pages/Donate';

import DashboardLayout from './pages/dashboard/index.jsx';
import DashboardHome from './pages/dashboard/DashboardHome';
import Progress from './pages/dashboard/ProgressPage.jsx';
import Certificates from './pages/dashboard/Certificates';
import Profile from './pages/dashboard/Profile';
import MessageBoard from './pages/dashboard/MessageBoard';

import AdminDashboard from './pages/AdminDashboard';
import StudentProgress from './pages/admin/StudentProgress';
import UserManagement from './pages/admin/UserManagement.jsx';
import CourseManagement from './pages/admin/CourseManagement';
import CourseForm from './pages/admin/CourseForm';
import { CourseFormWrapper, handleAddCourse } from './pages/admin/CourseForm';
import SiteUsage from './pages/admin/SiteUsage';
import AdminAnnouncementComposer from './pages/admin/AdminAnnouncementComposer';
import AdminInbox from './pages/admin/AdminInbox';
import ProtectedRoute from './components/ProtectedRoute';
import './index.css';

function App() {
  useEffect(() => {
    async function testSupabase() {
      const { data, error } = await supabase.from('courses').select('*');
      if (error) {
        console.error('❌ Supabase error:', error);
      } else {
        console.log('✅ Supabase data:', data);
      }
    }

    testSupabase();
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Router>
        <IdleTimer timeout={3600000} />
        <Navigation />
        <main className="flex-grow">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/course/:slug" element={
              <ProtectedRoute>
                <CourseDetails />
              </ProtectedRoute>
            } />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/donate" element={<Donate />} /> {/* ✅ New Route */}

            {/* Dashboard (Authenticated Users) */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }>
              <Route index element={<DashboardHome />} />
              <Route path="progress" element={<Progress />} />
              <Route path="certificates" element={<Certificates />} />
              <Route path="profile" element={<Profile />} />
              <Route path="messages" element={<MessageBoard />} />
            </Route>

            {/* Admin-only Routes */}
            <Route path="/admin" element={
              <ProtectedRoute requiredRole="admin">
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/users" element={
              <ProtectedRoute requiredRole="admin">
                <UserManagement />
              </ProtectedRoute>
            } />
            <Route path="/admin/courses" element={
              <ProtectedRoute requiredRole="admin">
                <CourseManagement />
              </ProtectedRoute>
            } />
            <Route path="/admin/courses/new" element={
              <ProtectedRoute requiredRole="admin">
                <CourseForm onSave={handleAddCourse} />
              </ProtectedRoute>
            } />
            <Route path="/admin/courses/edit/:id" element={
              <ProtectedRoute requiredRole="admin">
                <CourseFormWrapper onSave={handleAddCourse} />
              </ProtectedRoute>
            } />
            <Route path="/admin/analytics/progress" element={
              <ProtectedRoute requiredRole="admin">
                <StudentProgress />
              </ProtectedRoute>
            } />
            <Route path="/admin/analytics/usage" element={
              <ProtectedRoute requiredRole="admin">
                <SiteUsage />
              </ProtectedRoute>
            } />
            <Route path="/admin/announcements" element={
              <ProtectedRoute requiredRole="admin">
                <AdminAnnouncementComposer />
              </ProtectedRoute>
            } />
            <Route path="/admin/inbox" element={
  <ProtectedRoute requiredRole="admin">
    <AdminInbox />
  </ProtectedRoute>
} />
          </Routes>
        </main>
        <Footer />
      </Router>
      <Analytics />
      <Toaster />
    </div>
  );
}

export default App;
